import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 d-flex align-center" }
const _hoisted_2 = { class: "d-flex justify-space-around align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_class_picker = _resolveComponent("class-picker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_gender_picker = _resolveComponent("gender-picker")!
  const _component_age_picker = _resolveComponent("age-picker")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('features.nursery-web-account-management-children')), 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_menu, { "offset-y": "" }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps({
            class: "mr-2",
            color: "primary",
            variant: "outlined",
            disabled: _ctx.isFetching
          }, props), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("mdi-tray-arrow-down", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')), 1)
            ]),
            _: 1
          }, 16, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pdfDialog = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('children.invitationPdf')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportChildrenDialog = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('children.childCsv')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, { href: _ctx.importChildSampleCsvUrl }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.sampleCsv')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.importDialog = true)),
        disabled: _ctx.isFetching,
        color: "primary",
        class: "mr-2",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('children.batchImport')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        to: "/children/account-create",
        disabled: _ctx.isFetching
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.create')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-4 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.class')), 1),
                    _createVNode(_component_class_picker, {
                      classes: _ctx.classes,
                      modelValue: _ctx.classId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.classId) = $event)),
                      color: "primary"
                    }, null, 8, ["classes", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.lastName')), 1),
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      modelValue: _ctx.lastName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lastName) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.firstName')), 1),
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      modelValue: _ctx.firstName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.firstName) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.gender')), 1),
                    _createVNode(_component_gender_picker, {
                      modelValue: _ctx.gender,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gender) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.age')), 1),
                    _createVNode(_component_age_picker, {
                      modelValue: _ctx.age,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.age) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.searchFilter.isQuit,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchFilter.isQuit) = $event)),
                      color: "primary",
                      label: _ctx.$t('children.quitSchool')
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.search,
                  large: "",
                  color: "primary",
                  disabled: _ctx.isFetching,
                  class: "my-2 search-button",
                  variant: "flat",
                  loading: _ctx.isFetching
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.search')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled", "loading"]),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      class: "pt-4",
      items: _ctx.children,
      modelValue: _ctx.selectedChildren,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedChildren) = $event)),
      headers: _ctx.childrenTableHeaders,
      "item-value": "childId",
      "return-object": "",
      "items-per-page": -1,
      "show-select": "",
      loading: _ctx.isFetching,
      color: "primary"
    }, {
      loading: _withCtx(() => [
        _createVNode(_component_v_skeleton_loader, { type: "table-tbody" })
      ]),
      "item.name": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(`${item.lastName} ${item.firstName}`), 1)
      ]),
      "item.class": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.getClassName(item)), 1)
      ]),
      "item.gender": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(item.gender === "male" ? _ctx.$t('common.male') : _ctx.$t('common.female')), 1)
      ]),
      "item.age": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.yearsOld', { n: _ctx.getAgeBasedonBirthdate(item.dateOfBirth) })), 1)
      ]),
      "item.isFamilyAssociated": _withCtx(({ item }) => [
        (item.isFamilyAssociated)
          ? (_openBlock(), _createBlock(_component_v_chip, {
              key: 0,
              color: "success",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  start: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("mdi-check-circle", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.completed')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_chip, {
              key: 1,
              color: "grey",
              size: "small",
              variant: "outlined"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.incomplete')), 1)
              ]),
              _: 1
            }))
      ]),
      "item.edit": _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "outlined",
            class: "mr-2",
            size: "small",
            disabled: _ctx.isFetching,
            to: `/children/account/${item.childId}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('children.accountSettings')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "to"]),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            class: "mr-2",
            size: "small",
            disabled: _ctx.isFetching,
            to: `/children/document/${item.childId}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('children.childRecord')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "to"]),
          _createVNode(_component_v_btn, {
            color: "#EE6190",
            theme: "dark",
            variant: "flat",
            size: "small",
            disabled: _ctx.isFetching,
            to: `/parent/${item.childId}/document`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('children.parentRecord')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "to"])
        ])
      ]),
      bottom: _withCtx(() => [...(_cache[26] || (_cache[26] = []))]),
      _: 1
    }, 8, ["items", "modelValue", "headers", "loading"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.pdfDialog,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.pdfDialog) = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('children.invitationDownload')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pdfDialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          class: "mr-2",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downloadInvitationPdf(false))),
                          disabled: _ctx.isFetching,
                          color: "primary",
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.selectedOnly')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downloadInvitationPdf(true))),
                          disabled: _ctx.isFetching,
                          color: "primary",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.allChildren')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.memoruPdfDialog,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.memoruPdfDialog) = $event)),
      "max-width": "600px"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.importDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.importDialog) = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('children.batchImport')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          "align-self": "center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.csvFile')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          "align-self": "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_file_input, {
                              modelValue: _ctx.importFile,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.importFile) = $event)),
                              accept: ".csv",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "auto"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.importDialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.importCsv,
                          disabled: !_ctx.importFile,
                          loading: _ctx.isFetching,
                          color: "primary",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.import')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.exportChildrenDialog,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.exportChildrenDialog) = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('children.childDownload')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.pdfDialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.downloadChildrenCsv(false))),
                          class: "mr-2",
                          disabled: _ctx.isFetching,
                          color: "primary",
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.selectedOnly')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.downloadChildrenCsv(true))),
                          disabled: _ctx.isFetching,
                          color: "primary",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.allChildren')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}